import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import TrailDetails from './pages/trail-details';
import TrailDetailsOdGleceraDoGrebaje from './pages/trail-details-od-glecera-do-grebaje';
import TrailDetailsLegendeBrskova from './pages/trail-details-legende-brskova';
import TrailDetailsKanjonTare from './pages/trail-details-kanjon-tare';
import TrailDetailsInTheEmbraceOfForestAndThreeLakes from './pages/trail-details-in-the-embrace-of-forest-and-three-lakes';
import TrailDetailsZivotKrozVekoveGolija from './pages/trail-details-zivot-kroz-vekove-golija';
import TrailDetailsListeningToMedievalSerbia from './pages/trail-details-listening-to-the-pulse-of-medieval-serbia';
import TrailDetailsAndThereWasWaterLifeOfPeopleInMountainsAndWater from './pages/trail-details-and-there-was-water-life-of-people-in-mountains-and-water';
import TrailDetailsOnceUponATimeMythsAndLegendsOfMountainPeople from './pages/trail-details-once-upon-a-time-myths-and-legends-of-mountain-people';
import ThematicTrailsOverview from './pages/thematic-trails-overview';
import TourismOfferings from './pages/tourism-offerings';
import ContactAndPartnersPage from './pages/contact-and-partners';
import AboutProject from './pages/about-project';
import HeritageInteractiveMap from './pages/heritage-interactive-map';
import Homepage from './pages/homepage';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<Homepage />} />
        <Route path="/trail-details" element={<TrailDetails />} />
        <Route path="/trails/od-glecera-do-grebaje" element={<TrailDetailsOdGleceraDoGrebaje />} />
        <Route path="/trails/legende-brskova" element={<TrailDetailsLegendeBrskova />} />
        <Route path="/trails/kanjon-tare" element={<TrailDetailsKanjonTare />} />
        <Route path="/trail-details-in-the-embrace-of-forest-and-three-lakes" element={<TrailDetailsInTheEmbraceOfForestAndThreeLakes />} />
        <Route path="/trails/zivot-kroz-vekove-golija" element={<TrailDetailsZivotKrozVekoveGolija />} />
        <Route path="/trail-details-listening-to-the-pulse-of-medieval-serbia" element={<TrailDetailsListeningToMedievalSerbia />} />
        <Route path="/trail-details-and-there-was-water-life-of-people-in-mountains-and-water" element={<TrailDetailsAndThereWasWaterLifeOfPeopleInMountainsAndWater />} />
        <Route path="/trail-details-once-upon-a-time-myths-and-legends-of-mountain-people" element={<TrailDetailsOnceUponATimeMythsAndLegendsOfMountainPeople />} />
        <Route path="/thematic-trails-overview" element={<ThematicTrailsOverview />} />
        <Route path="/tourism-offerings" element={<TourismOfferings />} />
        <Route path="/contact-and-partners" element={<ContactAndPartnersPage />} />
        <Route path="/about-project" element={<AboutProject />} />
        <Route path="/heritage-interactive-map" element={<HeritageInteractiveMap />} />
        <Route path="/homepage" element={<Homepage />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;